module.exports = __webpack_public_path__ + "static/img/photo.0584d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/photo.png
// module id = c72g
// module chunks = 1